module.exports = __webpack_public_path__ + "assets/images/tutorial3.fef44e6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial3.png
// module id = 454
// module chunks = 1